import { useProjection } from './useProjection.js';
import { useCanvasPanelNode } from './projection-panel-node.jsx';

/** Separate projection assembly from the replaceable Canvas rendering. */
export const useCanvasProjection = (options) => {
  const { panelProps, ...projection } = useProjection(options);
  const canvasPanelNode = useCanvasPanelNode(panelProps);
  return { ...projection, canvasPanelNode };
};
export default useCanvasProjection;
